export enum ItemTypes {
  Window = 'window',
  ChannelStatus = 'channelStatus',
  AppointmentBoardCard = 'appointmentBoardCard',
  ConversationBoardCard = 'conversationBoardCard',
}
